// import React, { useState } from "react";
// import { FormFieldSet, TextEditor } from "../../../../../components";

// const TextEditorList = () => {
//   const handleContentChange = (content) => {
//     // Handle content changes
//     console.log("Content updated:", content);
//   };

//   const handleSave = (content) => {
//     // Save content to backend
//     saveToServer(content);
//   };

//   const handleExport = (format, content) => {
//     // Handle export in different formats
//     console.log(`Exporting as ${format}:`, content);
//   };

//   return (
//     <div className="flex-1 flex flex-col">
//       <TextEditor
//         initialContent="Welcome to the Rich Text Editor"
//         onContentChange={handleContentChange}
//         onSave={handleSave}
//         onExport={handleExport}
//         enableCollaboration={true}
//         enableAccessibility={true}
//         enableMobileOptimization={true}
//         maxHistorySize={100}
//         autoSaveInterval={30000}
//       />
//     </div>
//   );
// };

// export default TextEditorList;

import React, { useState } from "react";
import { CkTextEditor } from "../../../../../components";

const TextEditorList = () => {
  const [editorContent, setEditorContent] = useState(`
    <h1>Advanced Rich Text Editor</h1>
    <p>Welcome to our <strong>advanced</strong> rich text editor with <em>comprehensive</em> features!</p>
    
    <h2>Key Features</h2>
    <ul>
      <li><strong>Text Formatting:</strong> Bold, italic, underline, strikethrough, subscript, superscript</li>
      <li><strong>Advanced Tools:</strong> Tables, highlighting, find & replace</li>
      <li><strong>Document Management:</strong> Import/export HTML & TXT files</li>
      <li><strong>Media Support:</strong> Images with automatic resizing</li>
      <li><strong>Typography:</strong> Multiple fonts, sizes, and colors</li>
      <li><strong>Layout:</strong> Full-screen mode, word count, character limits</li>
    </ul>
    
    <h3>Sample Table</h3>
    <table border="1" style="border-collapse: collapse; width: 100%; margin: 10px 0;">
      <tr>
        <th style="padding: 8px; border: 1px solid #ccc; background-color: #f3f4f6;">Feature</th>
        <th style="padding: 8px; border: 1px solid #ccc; background-color: #f3f4f6;">Status</th>
        <th style="padding: 8px; border: 1px solid #ccc; background-color: #f3f4f6;">Description</th>
      </tr>
      <tr>
        <td style="padding: 8px; border: 1px solid #ccc;">Tables</td>
        <td style="padding: 8px; border: 1px solid #ccc;">✅ Available</td>
        <td style="padding: 8px; border: 1px solid #ccc;">Create responsive tables with custom rows/columns</td>
      </tr>
      <tr>
        <td style="padding: 8px; border: 1px solid #ccc;">Highlighting</td>
        <td style="padding: 8px; border: 1px solid #ccc;">✅ Available</td>
        <td style="padding: 8px; border: 1px solid #ccc;">Highlight text with customizable colors</td>
      </tr>
    </table>
    
    <blockquote>
      "This editor provides a professional writing experience with all the tools you need for content creation."
    </blockquote>
    
    <pre>// Code example
const editor = new AdvancedTextEditor({
  features: ['tables', 'highlighting', 'export'],
  wordCount: true,
  fullScreen: true
});</pre>
    
    <p>Try all the features using the comprehensive toolbar above! 🚀</p>
  `);
  const [showHtml, setShowHtml] = useState(false);
  const [editorMode, setEditorMode] = useState("normal"); // normal, readonly, limited

  return (
    <div className=" bg-gray-50 py-8">
      <div className="">
        <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">
            Advanced Rich Text Editor Demo
          </h1>

          {/* Editor Mode Selector */}
          <div className="mb-6">
            <div className="flex flex-wrap justify-center gap-2 mb-4">
              <button
                onClick={() => setEditorMode("normal")}
                className={`px-4 py-2 rounded transition-colors ${
                  editorMode === "normal"
                    ? "bg-blue-500 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
              >
                Full Editor
              </button>
              <button
                onClick={() => setEditorMode("readonly")}
                className={`px-4 py-2 rounded transition-colors ${
                  editorMode === "readonly"
                    ? "bg-blue-500 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
              >
                Read-Only Mode
              </button>
              <button
                onClick={() => setEditorMode("limited")}
                className={`px-4 py-2 rounded transition-colors ${
                  editorMode === "limited"
                    ? "bg-blue-500 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
              >
                Limited Mode (500 chars)
              </button>
              <button
                onClick={() => setShowHtml(!showHtml)}
                className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
              >
                {showHtml ? "Hide HTML" : "Show HTML"}
              </button>
            </div>

            <CkTextEditor
              value={editorContent}
              onChange={setEditorContent}
              placeholder="Start typing your content here..."
              height="500px"
              className="mb-4"
              showWordCount={true}
              maxLength={editorMode === "limited" ? 500 : null}
              readOnly={editorMode === "readonly"}
            />
          </div>

          {showHtml && (
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-700 mb-2">
                Generated HTML:
              </h3>
              <pre className="bg-gray-100 p-4 rounded border overflow-x-auto text-sm">
                <code>{editorContent}</code>
              </pre>
            </div>
          )}

          <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-6">
            <div>
              <h3 className="text-lg font-semibold text-gray-700 mb-3">
                📝 Text Formatting:
              </h3>
              <ul className="space-y-2 text-gray-600 text-sm">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                  Bold, Italic, Underline, Strikethrough
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                  Subscript & Superscript
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                  Text Highlighting with Custom Colors
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                  Clear Formatting
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                  Font Family & Size Selection
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                  Text & Background Colors
                </li>
              </ul>

              <h3 className="text-lg font-semibold text-gray-700 mb-3 mt-6">
                📐 Layout & Structure:
              </h3>
              <ul className="space-y-2 text-gray-600 text-sm">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                  Text Alignment (Left, Center, Right, Justify)
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                  Lists (Ordered & Unordered)
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                  Indent & Outdent
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                  Headings (H1-H6) & Paragraphs
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                  Code Blocks & Blockquotes
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-700 mb-3">
                🔧 Advanced Tools:
              </h3>
              <ul className="space-y-2 text-gray-600 text-sm">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                  Table Creation (Custom Rows/Columns)
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                  Find & Replace with Regex Support
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                  Full-Screen Editing Mode
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                  Word Count & Character Limits
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                  Copy, Cut, Paste Operations
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                  Undo/Redo with History
                </li>
              </ul>

              <h3 className="text-lg font-semibold text-gray-700 mb-3 mt-6">
                🔗 Media & Links:
              </h3>
              <ul className="space-y-2 text-gray-600 text-sm">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
                  Link Insertion with Modal
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
                  Image Embedding (URL-based)
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-orange-500 rounded-full mr-3"></span>
                  Link Removal
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-700 mb-3">
                💾 Document Management:
              </h3>
              <ul className="space-y-2 text-gray-600 text-sm">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-red-500 rounded-full mr-3"></span>
                  Export as HTML
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-red-500 rounded-full mr-3"></span>
                  Export as Plain Text
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-red-500 rounded-full mr-3"></span>
                  Import HTML/TXT Files
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-red-500 rounded-full mr-3"></span>
                  Print Document
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-red-500 rounded-full mr-3"></span>
                  Read-Only Mode
                </li>
              </ul>

              <h3 className="text-lg font-semibold text-gray-700 mb-3 mt-6">
                ⌨️ Keyboard Shortcuts:
              </h3>
              <div className="space-y-2 text-sm text-gray-600">
                <div className="flex justify-between">
                  <span>Bold:</span>
                  <kbd className="px-2 py-1 bg-gray-200 rounded text-xs">
                    Ctrl + B
                  </kbd>
                </div>
                <div className="flex justify-between">
                  <span>Italic:</span>
                  <kbd className="px-2 py-1 bg-gray-200 rounded text-xs">
                    Ctrl + I
                  </kbd>
                </div>
                <div className="flex justify-between">
                  <span>Underline:</span>
                  <kbd className="px-2 py-1 bg-gray-200 rounded text-xs">
                    Ctrl + U
                  </kbd>
                </div>
                <div className="flex justify-between">
                  <span>Undo:</span>
                  <kbd className="px-2 py-1 bg-gray-200 rounded text-xs">
                    Ctrl + Z
                  </kbd>
                </div>
                <div className="flex justify-between">
                  <span>Redo:</span>
                  <kbd className="px-2 py-1 bg-gray-200 rounded text-xs">
                    Ctrl + Y
                  </kbd>
                </div>
                <div className="flex justify-between">
                  <span>Copy:</span>
                  <kbd className="px-2 py-1 bg-gray-200 rounded text-xs">
                    Ctrl + C
                  </kbd>
                </div>
                <div className="flex justify-between">
                  <span>Paste:</span>
                  <kbd className="px-2 py-1 bg-gray-200 rounded text-xs">
                    Ctrl + V
                  </kbd>
                </div>
                <div className="flex justify-between">
                  <span>Indent:</span>
                  <kbd className="px-2 py-1 bg-gray-200 rounded text-xs">
                    Tab
                  </kbd>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 grid md:grid-cols-2 gap-6">
            <div className="p-4 bg-blue-50 rounded-lg">
              <h4 className="font-semibold text-blue-800 mb-2">
                🚀 Quick Start Guide:
              </h4>
              <ul className="text-blue-700 text-sm space-y-1">
                <li>• Select text and use toolbar buttons for formatting</li>
                <li>• Use dropdown menus for headings and font changes</li>
                <li>• Click color pickers to customize text appearance</li>
                <li>• Try the table tool to create structured content</li>
                <li>• Use Find & Replace for bulk text changes</li>
                <li>• Toggle full-screen mode for distraction-free writing</li>
              </ul>
            </div>

            <div className="p-4 bg-green-50 rounded-lg">
              <h4 className="font-semibold text-green-800 mb-2">
                💡 Pro Tips:
              </h4>
              <ul className="text-green-700 text-sm space-y-1">
                <li>• Double-click to select entire words quickly</li>
                <li>• Use highlighting to mark important sections</li>
                <li>• Export your work as HTML to preserve formatting</li>
                <li>• Import existing documents to continue editing</li>
                <li>• Monitor word count for content length requirements</li>
                <li>• Use read-only mode for document review</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Additional Demo Sections */}
        <div className="grid md:grid-cols-2 gap-6">
          <div className="bg-white rounded-lg shadow-lg p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              📊 Usage Statistics
            </h2>
            <div className="space-y-3">
              <div className="flex justify-between items-center">
                <span className="text-gray-600">Current Mode:</span>
                <span className="font-semibold capitalize">{editorMode}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-600">Content Length:</span>
                <span className="font-semibold">
                  {editorContent.replace(/<[^>]*>/g, "").length} chars
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-600">HTML Size:</span>
                <span className="font-semibold">
                  {editorContent.length} chars
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-600">Word Count:</span>
                <span className="font-semibold">
                  {
                    editorContent
                      .replace(/<[^>]*>/g, "")
                      .trim()
                      .split(/\s+/).length
                  }{" "}
                  words
                </span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              🎯 Feature Highlights
            </h2>
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-gray-600">Tables</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 rounded text-xs">
                  Advanced
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-gray-600">Text Highlighting</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 rounded text-xs">
                  Advanced
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-gray-600">Find & Replace</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 rounded text-xs">
                  Advanced
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-gray-600">Document Export</span>
                <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs">
                  Professional
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-gray-600">Full-Screen Mode</span>
                <span className="px-2 py-1 bg-purple-100 text-purple-800 rounded text-xs">
                  Premium
                </span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-gray-700 mb-3">
              Keyboard Shortcuts:
            </h3>
            <div className="space-y-2 text-sm text-gray-600">
              <div className="flex justify-between">
                <span>Bold:</span>
                <kbd className="px-2 py-1 bg-gray-200 rounded text-xs">
                  Ctrl + B
                </kbd>
              </div>
              <div className="flex justify-between">
                <span>Italic:</span>
                <kbd className="px-2 py-1 bg-gray-200 rounded text-xs">
                  Ctrl + I
                </kbd>
              </div>
              <div className="flex justify-between">
                <span>Underline:</span>
                <kbd className="px-2 py-1 bg-gray-200 rounded text-xs">
                  Ctrl + U
                </kbd>
              </div>
              <div className="flex justify-between">
                <span>Undo:</span>
                <kbd className="px-2 py-1 bg-gray-200 rounded text-xs">
                  Ctrl + Z
                </kbd>
              </div>
              <div className="flex justify-between">
                <span>Redo:</span>
                <kbd className="px-2 py-1 bg-gray-200 rounded text-xs">
                  Ctrl + Y
                </kbd>
              </div>
              <div className="flex justify-between">
                <span>Indent:</span>
                <kbd className="px-2 py-1 bg-gray-200 rounded text-xs">Tab</kbd>
              </div>
            </div>

            <div className="mt-6">
              <h4 className="font-semibold text-gray-700 mb-2">Usage:</h4>
              <div className="text-sm text-gray-600 space-y-1">
                <p>• Select text and use toolbar buttons</p>
                <p>• Use dropdown menus for formatting</p>
                <p>• Click color pickers to change colors</p>
                <p>• Double-click to select words</p>
                <p>• Use keyboard shortcuts for quick formatting</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 p-4 bg-blue-50 rounded-lg">
          <h4 className="font-semibold text-blue-800 mb-2">💡 Pro Tips:</h4>
          <ul className="text-blue-700 text-sm space-y-1">
            <li>• Select text before applying formatting for best results</li>
            <li>• Use the format dropdown to create headings and paragraphs</li>
            <li>• The editor supports copy/paste from other applications</li>
            <li>
              • Images can be inserted via URL (try with any online image)
            </li>
            <li>• The editor automatically saves your formatting as HTML</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TextEditorList;
